import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
//import {Chart} from 'primereact/chart';
import { useTranslation, withTranslation } from 'react-i18next';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import * as proyectAction from '../store/actions/proyectAction';
import LoaddingComponent from './LoadingComponent';

const MapPlantas = global => {
  const { t } = useTranslation();
  useEffect(() => {
    update();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (global.global?.plantas) {
      setmarcadorActual(global.global?.plantas[0]);
    }
    // eslint-disable-next-line
  }, [global.global]);

  useEffect(() => {
    if (global.global?.plantas) {
      setmarcadorActual(global.global?.plantas[0]);
    }
    // eslint-disable-next-line
  }, [global.global]);

  function update() {
    global.setProyectPlantaVisible(false);
    global.setBreadCrumb({
      label: global.breadCrumbLabel,
      url: global.breadCrumbUrl,
    });
  }
  const [mapa, SetMapa] = useState(true);
  const positions = global.global.plantas;
  if (positions[positions?.length - 1].to === 'config') {
    positions.splice(positions.length - 1, 1);
  }
  const [marcadorActual, setmarcadorActual] = useState(
    positions !== null ? positions[0] : null,
  );
  const setPlantaActual = planta => {
    global.setPlantaActual(planta);
  };
  const markers =
    positions !== null &&
    positions.map(function (position, index) {
      if (position.to === 'config') {
        return null;
      } else {
        return (
          <Marker key={index} position={[position.latitud, position.longitud]}>
            <Popup>
              <div className="center">
                <h2>{position.nombre}</h2>
                <div>
                  <NavLink
                    activeClassName="active-route"
                    to={position.to}
                    exact={true}
                    onClick={e => {
                      e.preventDefault();
                      actualizarMapa(position);
                    }}
                  >
                    <span>{t('Centrar en el mapa')}</span>
                  </NavLink>
                </div>
                <div>
                  <NavLink
                    activeClassName="active-route"
                    to={position.to}
                    onClick={() => setPlantaActual(position)}
                    exact={true}
                  >
                    <span>{t('Ver detalles')}</span>
                  </NavLink>
                </div>
              </div>
            </Popup>
          </Marker>
        );
      }
    });

  const actualizarMapa = position => {
    if (
      marcadorActual.latitud === position.latitud &&
      marcadorActual.longitud === position.longitud
    ) {
      SetMapa(!mapa);
    } else {
      setmarcadorActual(position);
    }
  };

  const nameBodyTemplate = rowData => {
    return BodyTemplate(t('Nombre'), rowData.label);
  };
  const picoBodyTemplate = rowData => {
    return BodyTemplate(t('Potencia Pico'), rowData.pico);
  };
  const probjetivoBodyTemplate = rowData => {
    return BodyTemplate(t('PR Objetivo'), rowData.probjetivo);
  };
  const direccionBodyTemplate = rowData => {
    return BodyTemplate(t('Direccion'), rowData.direccion);
  };
  const paisBodyTemplate = rowData => {
    return BodyTemplate(t('Pais'), rowData.pais);
  };
  const BodyTemplate = (label, field) => {
    return (
      <React.Fragment>
        <span className="p-column-title">{label}</span>
        {field}
      </React.Fragment>
    );
  };

  const tabla = () => {
    return (
      <div className="datatable-responsive-demo">
        <div className="card">
          <DataTable
            value={positions}
            className="p-datatable-responsive-demo roboto"
            onSelectionChange={e => actualizarMapa(e.value)}
            selectionMode="single"
            dataKey="id"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate=""
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
          >
            <Column
              field="label"
              header={t('Nombre')}
              sortable
              body={nameBodyTemplate}
            ></Column>
            <Column
              field="pico"
              header={t('Potencia Pico')}
              sortable
              body={picoBodyTemplate}
            ></Column>
            <Column
              field="probjetivo"
              header={t('PR Objetivo')}
              sortable
              body={probjetivoBodyTemplate}
            ></Column>
            <Column
              field="direccion"
              header={t('Direccion')}
              sortable
              body={direccionBodyTemplate}
            ></Column>
            <Column
              field="pais"
              header={t('Pais')}
              sortable
              body={paisBodyTemplate}
            ></Column>
          </DataTable>
        </div>
      </div>
    );
  };
  const respuesta = () => {
    if (positions === null || positions[0] === undefined) {
      return (
        <div className="p-col-12 marginbottom40px">
          <div className="card p-col-12 margin5">Sin datos</div>
        </div>
      );
    } else {
      return (
        <div className="p-col-12 marginbottom40px">
          <div className="card p-col-12 margin5">
            {marcadorActual !== null ? (
              <Map
                center={[marcadorActual.latitud, marcadorActual.longitud]}
                zoom={8}
                key={mapa}
              >
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {markers}
              </Map>
            ) : (
              <LoaddingComponent />
            )}
          </div>
          {tabla()}
        </div>
      );
    }
  };
  return respuesta();
};
const mapStateToProps = rootReducer => {
  return { global: rootReducer.proyect };
};
const mapDispatchToProps = proyectAction;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('translations')(MapPlantas));
